// CurrencySymbols.js
function customRound(value) {
  let scaled = value * 1000;
  let intPart = Math.floor(scaled);
  let thirdDecimalDigit = intPart % 10;

  let roundedNumber;
  if (thirdDecimalDigit <= 5) {
    roundedNumber = Math.floor(value * 100) / 100;
  } else {
    roundedNumber = Math.ceil(value * 100) / 100;
  }

  return roundedNumber;
}

const Reportcurrencysymbols = (value, symbol, FractionDigits, currencySymbolLocation = "BEFORE NUMBER") => {
  try {
    const numericValue = Number(value);
    if (isNaN(numericValue)) {
      return `${symbol || ""} ${value}`;
    }

    const positiveValues = Math.abs(value);
    const roundedAmount = customRound(positiveValues);
    const formattedValue = roundedAmount.toLocaleString("en-US", {
      minimumFractionDigits: FractionDigits,
      maximumFractionDigits: FractionDigits,
    });

    const isNegative = value < 0;
    const currencySymbol = symbol?.CurrencySymbol || symbol || "";

    return currencySymbolLocation === "AFTER NUMBER"
      ? `${isNegative ? "-" : ""}${formattedValue}${currencySymbol}`
      : `${isNegative ? "-" : ""}${currencySymbol}${formattedValue}`;
  } catch (error) {
    console.log("Error in CurrencySymbols:", error);
    return value;
  }
};

export default Reportcurrencysymbols;
